import { queryOptions, useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { deserializeEleve } from './serializer';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { Eleve } from 'types/eleves';

export const ELEVES_ACCOUNT_KEY = 'elevesData';

function elevesQuery<A = Eleve[]>(
  schoolyearId: string,
  schoolId: string,
  userLocation: string,
  select?: (data: Eleve[]) => A,
) {
  return queryOptions({
    queryKey: [ELEVES_ACCOUNT_KEY, schoolyearId, schoolId],
    queryFn: () =>
      request(`/schoolyears/${schoolyearId}/schools/${schoolId}/eleves`, {
        method: 'GET',
      }).then(({ data }: { data: any[] | undefined }) =>
        (data || []).map(eleve => deserializeEleve(eleve, userLocation)),
      ),
    select,
    refetchOnWindowFocus: false,
  });
}

export default function useEleves() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const user = useUser();
  return useQuery(elevesQuery(schoolyear.id, school.id, user.location));
}

export function useEleveCount() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const user = useUser();
  return useQuery(
    elevesQuery<number>(
      schoolyear.id,
      school.id,
      user.location,
      data => (data || []).length,
    ),
  );
}

export function useElevesData() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const user = useUser();
  return useQuery(
    elevesQuery<Eleve[]>(schoolyear.id, school.id, user.location, data => data),
  );
}
